import { Theme } from "common";

// Styles to keep the Table Header Label text white
export const whiteTableHeaderLabel = {
  "& .MuiTableSortLabel-root": {
    color: `${Theme.palette.common.white} !important`,
  },
  "& .MuiTableSortLabel-root:hover": {
    color: Theme.palette.common.white,
  },
  "&.Mui-active": {
    color: Theme.palette.common.white,
  },
  "& .MuiTableSortLabel-icon": {
    color: `${Theme.palette.common.white} !important`,
    alignSelf: "center",
  },
};
